import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { IStudyHallState } from '@/store/modules/studyhall/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const studyHallModule: Module<IStudyHallState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
